// extracted by mini-css-extract-plugin
export var footer = "Footer2025-module--footer--2fa65";
export var footerInner = "Footer2025-module--footerInner--0bfaf";
export var footerThemesPage = "Footer2025-module--footerThemesPage--9efff";
export var orgLink = "Footer2025-module--orgLink--d20c7";
export var social = "Footer2025-module--social--5c47b";
export var socialIcon = "Footer2025-module--socialIcon--68527";
export var socialLink = "Footer2025-module--socialLink--06f6a";